import React from 'react';

import { bemCssModules } from '@cryptoboyio/mercuryo-lab/utils';
import { MaskitoOptions } from '@maskito/core';
import { useMaskito } from '@maskito/react';

import Input, { TInput } from '@components/Input';

import style from './InputMask.scss';

const cn = bemCssModules(style, 'InputMask');

export type InputMaskType = {
  maskOptions: MaskitoOptions;
  onChange: TInput['onChange'];
} & TInput;

const InputMask: CustomFC<InputMaskType> = props => {
  const { maskOptions, className, onChange, ...rest } = props;

  const inputRef = useMaskito({ options: maskOptions });

  return <Input className={cn(null, [className])} ref={inputRef} onInput={onChange} {...rest} />;
};

export default InputMask;
